import { Container } from '@/platform/ui';
import Navigation from './components/Navigation';
import Statistics from './components/Statistics';

const DashboardView = () => {
    return (
        <Container fluid>
            <Navigation reload={['high_premiums', 'actual_savings']} />
            <Statistics />
        </Container>
    );
};

export default DashboardView;
